module.exports = __webpack_public_path__ + "img/Israel_Airports_Authority.5ef7965d.svg";